import * as React from "react";
const NoAccessibilityIssuesIllustration = props => (
  <svg
    width={208}
    height={128}
    viewBox="0 0 208 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M188.626 103.95C192.895 103.95 196.356 100.487 196.356 96.215C196.356 91.943 192.895 88.48 188.626 88.48H144.455C148.724 88.48 152.185 85.0169 152.185 80.745C152.185 76.473 148.724 73.01 144.455 73.01H168.749C173.018 73.01 176.479 69.5469 176.479 65.275C176.479 61.003 173.018 57.54 168.749 57.54H157.514C152.131 57.54 147.768 54.0769 147.768 49.805C147.768 46.957 149.976 44.3787 154.393 42.07C158.663 42.07 162.123 38.6069 162.123 34.335C162.123 30.063 158.663 26.6 154.393 26.6H45.8202C41.5511 26.6 38.0903 30.063 38.0903 34.335C38.0903 38.6069 41.5511 42.07 45.8202 42.07H19.6723C15.4032 42.07 11.9424 45.533 11.9424 49.805C11.9424 54.0769 15.4032 57.54 19.6723 57.54H46.9245C51.1936 57.54 54.6544 61.003 54.6544 65.275C54.6544 69.5469 51.1936 73.01 46.9245 73.01H36.2364C31.9673 73.01 28.5065 76.473 28.5065 80.745C28.5065 85.0169 31.9673 88.48 36.2364 88.48H63.4886C59.2195 88.48 55.7587 91.943 55.7587 96.215C55.7587 100.487 59.2195 103.95 63.4886 103.95H188.626ZM188.626 73.01C192.895 73.01 196.356 69.5469 196.356 65.275C196.356 61.003 192.895 57.54 188.626 57.54C184.357 57.54 180.896 61.003 180.896 65.275C180.896 69.5469 184.357 73.01 188.626 73.01Z"
      fill="#F3F7FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M145.32 9.6001H68.4043C67.2185 9.6001 66.2573 10.5614 66.2573 11.7471V116.253C66.2573 117.439 67.2185 118.4 68.4043 118.4H145.32C146.506 118.4 147.467 117.439 147.467 116.253V11.7471C147.467 10.5614 146.506 9.6001 145.32 9.6001Z"
      fill="white"
      stroke="#B3DAFF"
      strokeWidth={1.275}
    />
    <path
      d="M105.841 52.1001C115.185 52.1001 122.76 44.4889 122.76 35.1001C122.76 25.7113 115.185 18.1001 105.841 18.1001C96.4971 18.1001 88.9224 25.7113 88.9224 35.1001C88.9224 44.4889 96.4971 52.1001 105.841 52.1001Z"
      fill="#F3F7FF"
      stroke="#0969DA"
      strokeWidth={1.275}
      strokeLinecap="round"
    />
    <path
      d="M105.537 27.144C106.227 27.144 106.787 26.5816 106.787 25.8878C106.787 25.194 106.227 24.6316 105.537 24.6316C104.846 24.6316 104.286 25.194 104.286 25.8878C104.286 26.5816 104.846 27.144 105.537 27.144Z"
      fill="#0969DA"
      stroke="#0969DA"
      strokeWidth={1.275}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.578 45.5683L105.537 36.2863M105.537 36.2863L109.496 45.5683M105.537 36.2863V32.3082M97.6186 29.6562L105.537 32.3082M105.537 32.3082L113.454 29.6562"
      stroke="#0969DA"
      strokeWidth={2.125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.3786 66.852C92.3786 66.3825 92.7573 66.002 93.2245 66.002H121.986C122.453 66.002 122.832 66.3825 122.832 66.852V67.702C122.832 68.1714 122.453 68.552 121.986 68.552H93.2245C92.7573 68.552 92.3786 68.1714 92.3786 67.702V66.852Z"
      fill="#ADD6FE"
    />
    <path
      d="M92.3786 71.952C92.3786 71.4825 92.7573 71.102 93.2245 71.102H105.914C106.381 71.102 106.759 71.4825 106.759 71.952V72.802C106.759 73.2714 106.381 73.652 105.914 73.652H93.2245C92.7573 73.652 92.3786 73.2714 92.3786 72.802V71.952Z"
      fill="#ADD6FE"
    />
    <path
      d="M92.3786 84.702C92.3786 84.2325 92.7573 83.852 93.2245 83.852H121.986C122.453 83.852 122.832 84.2325 122.832 84.702V85.552C122.832 86.0214 122.453 86.402 121.986 86.402H93.2245C92.7573 86.402 92.3786 86.0214 92.3786 85.552V84.702Z"
      fill="#ADD6FE"
    />
    <path
      d="M92.3786 89.802C92.3786 89.3325 92.7573 88.952 93.2245 88.952H105.914C106.381 88.952 106.759 89.3325 106.759 89.802V90.652C106.759 91.1214 106.381 91.502 105.914 91.502H93.2245C92.7573 91.502 92.3786 91.1214 92.3786 90.652V89.802Z"
      fill="#ADD6FE"
    />
    <path
      d="M92.3786 102.552C92.3786 102.083 92.7573 101.702 93.2245 101.702H121.986C122.453 101.702 122.832 102.083 122.832 102.552V103.402C122.832 103.871 122.453 104.252 121.986 104.252H93.2245C92.7573 104.252 92.3786 103.871 92.3786 103.402V102.552Z"
      fill="#ADD6FE"
    />
    <path
      d="M92.3786 107.652C92.3786 107.183 92.7573 106.802 93.2245 106.802H105.914C106.381 106.802 106.759 107.183 106.759 107.652V108.502C106.759 108.971 106.381 109.352 105.914 109.352H93.2245C92.7573 109.352 92.3786 108.971 92.3786 108.502V107.652Z"
      fill="#ADD6FE"
    />
    <path
      d="M79.858 73.6519H77.6211C77.363 73.6519 77.152 73.4399 77.152 73.1806V70.9356C77.152 70.6763 77.363 70.4644 77.6211 70.4644H79.8552C80.1133 70.4644 80.3243 70.6763 80.3243 70.9356V73.1806C80.327 73.4399 80.1161 73.6519 79.858 73.6519Z"
      stroke="#B3DAFF"
      strokeWidth={0.53125}
      strokeMiterlimit={10}
    />
    <path
      d="M78.3428 73.0144H79.4524C83.1812 66.2174 88.5719 65.707 88.5719 65.707V60.9019C81.8704 64.4796 78.8952 71.7869 78.8952 71.7869C78.8952 71.7869 77.9378 68.7196 74.614 67.3403V70.7139C74.614 70.7163 76.8307 70.7661 78.3428 73.0144Z"
      fill="#0969DA"
    />
    <path
      d="M79.8579 91.502H77.621C77.3629 91.502 77.152 91.29 77.152 91.0307V88.7857C77.152 88.5264 77.3629 88.3145 77.621 88.3145H79.8551C80.1133 88.3145 80.3242 88.5264 80.3242 88.7857V91.0307C80.327 91.29 80.116 91.502 79.8579 91.502Z"
      stroke="#B3DAFF"
      strokeWidth={0.53125}
      strokeMiterlimit={10}
    />
    <path
      d="M78.3428 90.8645H79.4524C83.1812 84.0675 88.5719 83.5571 88.5719 83.5571V78.752C81.8704 82.3297 78.8952 89.637 78.8952 89.637C78.8952 89.637 77.9378 86.5697 74.614 85.1904V88.5639C74.614 88.5664 76.8307 88.6162 78.3428 90.8645Z"
      fill="#0969DA"
    />
    <path
      d="M79.8579 109.352H77.621C77.3629 109.352 77.152 109.14 77.152 108.881V106.636C77.152 106.376 77.3629 106.165 77.621 106.165H79.8551C80.1133 106.165 80.3242 106.376 80.3242 106.636V108.881C80.327 109.14 80.116 109.352 79.8579 109.352Z"
      stroke="#B3DAFF"
      strokeWidth={0.53125}
      strokeMiterlimit={10}
    />
    <path
      d="M78.3428 108.715H79.4524C83.1812 101.918 88.5719 101.407 88.5719 101.407V96.6021C81.8704 100.18 78.8952 107.487 78.8952 107.487C78.8952 107.487 77.9378 104.42 74.614 103.04V106.414C74.614 106.417 76.8307 106.466 78.3428 108.715Z"
      fill="#0969DA"
    />
    <path
      d="M61.8904 95.8821L63.2397 95.2032C63.2707 95.1886 63.2397 95.1428 63.2148 95.1574L61.8656 95.8383C61.8345 95.8529 61.8656 95.8987 61.8904 95.8821Z"
      fill="black"
    />
    <path
      d="M148.138 63.1501C147.991 63.1501 147.845 63.172 147.711 63.2155C144.699 64.1652 141.522 64.7897 138.274 65.0703C136.027 65.2798 133.759 65.3332 131.498 65.2297C131.208 65.2147 130.922 65.2904 130.708 65.4386C130.495 65.5869 130.374 65.7946 130.373 66.0121V82.7696C130.373 89.1115 134.907 94.9717 142.267 98.1423L147.606 100.445C147.767 100.514 147.948 100.55 148.133 100.55L148.138 63.1501Z"
      fill="#F3F7FF"
    />
    <path
      d="M147.364 89.8018C152.503 89.8018 156.67 85.6157 156.67 80.4518C156.67 75.2879 152.503 71.1018 147.364 71.1018C142.225 71.1018 138.059 75.2879 138.059 80.4518C138.059 85.6157 142.225 89.8018 147.364 89.8018Z"
      fill="#0969DA"
    />
    <path
      d="M145.957 83.8543L145.954 83.8519C145.955 83.8528 145.956 83.8536 145.957 83.8543ZM146.358 83.9094V84.7294C146.358 84.9289 146.136 85.0519 145.959 84.9469L145.572 84.7029L145.479 84.6514C145.472 84.6477 144.711 84.1976 143.54 83.5329L143.447 83.4807C143.35 83.426 143.271 83.3476 143.216 83.253C143.162 83.1591 143.134 83.0527 143.135 82.947L143.135 80.905V78.8597C143.135 78.7449 143.168 78.6328 143.229 78.5366C143.29 78.4399 143.378 78.3604 143.468 78.3177L145.156 77.3602L145.249 77.3071C145.279 77.2898 145.279 77.2898 145.342 77.255L146.958 76.339L147.053 76.2839C147.157 76.2251 147.275 76.1971 147.394 76.2026C147.51 76.2081 147.624 76.2454 147.702 76.3004L149.385 77.2545L149.478 77.3061C149.485 77.3102 150.047 77.6291 151.188 78.2768L151.282 78.3293C151.378 78.3842 151.457 78.4624 151.512 78.557C151.566 78.6506 151.594 78.7571 151.594 78.863L151.594 80.5666C151.594 80.7639 151.376 80.8873 151.202 80.7885L150.476 80.3766C150.395 80.3308 150.346 80.2462 150.346 80.1547V79.2125L148.886 78.3842C148.873 78.3775 148.844 78.3616 148.763 78.3154L147.364 77.5207L145.91 78.3451C145.896 78.3543 145.896 78.3543 145.886 78.3599C145.883 78.3621 145.848 78.3822 145.781 78.4201L144.383 79.2126V82.5975L146.07 83.5733C146.081 83.5784 146.1 83.5891 146.196 83.6437L146.237 83.6791L146.259 83.7087C146.321 83.757 146.358 83.8307 146.358 83.9094ZM150.323 81.4529C150.323 81.2474 150.53 81.1188 150.695 81.2214L151.47 81.7055C151.547 81.7532 151.594 81.8415 151.594 81.937V82.6453C151.594 82.715 151.569 82.7819 151.523 82.8319L151.2 83.186C151.07 83.3661 150.874 83.4391 150.698 83.3302L148.183 81.7603L148.183 84.7162C148.193 84.8409 148.145 84.9629 148.054 85.0418C147.973 85.1121 147.973 85.1121 147.583 85.4514C147.518 85.5159 147.434 85.5519 147.345 85.5519C147.152 85.5519 146.995 85.3833 146.995 85.1753L146.996 81.2214L146.596 81.0208L146.396 81.1444C146.384 81.1533 146.393 81.1478 146.167 81.2885C145.996 81.3959 145.781 81.3389 145.682 81.1562C145.661 81.1166 145.661 81.1166 145.561 80.9298L145.44 80.7058C145.341 80.5217 145.394 80.2902 145.564 80.1845C145.602 80.1611 145.602 80.1611 145.776 80.0533L146.302 79.7273L146.394 79.6715C146.505 79.5863 146.653 79.5785 146.772 79.6528L146.892 79.7278L150.323 81.6104V81.4529Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.693 65.0708C153.6 64.7902 150.573 64.1656 147.705 63.2159C147.445 63.1282 147.151 63.1282 146.891 63.2159C144.022 64.1656 140.995 64.7902 137.901 65.0708C135.76 65.2802 133.6 65.3336 131.447 65.2301C131.17 65.2147 130.897 65.2901 130.693 65.4384C130.489 65.5868 130.374 65.7947 130.373 66.0125V82.7698C130.373 89.1116 134.693 94.9717 141.705 98.1423L146.791 100.445C147.102 100.585 147.484 100.585 147.794 100.445L152.88 98.1423C159.892 94.971 164.21 89.1112 164.21 82.7698V66.0094C164.21 65.7918 164.094 65.5842 163.891 65.4359C163.688 65.2876 163.415 65.2119 163.138 65.2269C160.988 65.331 158.831 65.2787 156.693 65.0708Z"
      stroke="#BBDFFF"
      strokeWidth={1.25}
    />
  </svg>
);
export default NoAccessibilityIssuesIllustration;
